export type ApiResult<T> =
  | { ok: true; data: T }
  | { ok: false; status: number; error: string; errors?: Record<string, string> }

// Foutcodes die meer dan één /beheer-scherm kan terugkrijgen, met één
// Nederlandse tekst per code. Stond eerder per pagina apart uitgeschreven,
// waardoor dezelfde storing in /beheer en /beheer/toewijzen twee
// verschillende dingen kon beweren zodra iemand er één bijwerkte — net het
// soort verwarring dat dit publiek (zie CLAUDE.md) het slechtst verdraagt.
// Paginaspecifieke codes horen hier niet thuis: geef die als `fallback` of
// handel ze af vóór deze aanroep.
const GEDEELDE_FOUTEN: Record<string, string> = {
  'season-close-in-progress':
    'Het seizoen wordt op dit moment afgesloten — de plattegrond kan even niet gewijzigd worden. '
    + 'Probeer het over een paar tellen opnieuw.',
  'map-not-trusted':
    'De plattegrond is niet meer betrouwbaar voor deze (gesloten) editie — mogelijk is hij herdraaid na '
    + 'het sluiten van het seizoen. Sluit het seizoen opnieuw af, of wacht tot de volgende editie.',
  'wrong-edition':
    'Deze inschrijving hoort bij een afgesloten editie — die kan je niet meer wijzigen. '
    + 'Herlaad de pagina om de lopende editie te zien.',
  'season-closed':
    'Het seizoen is gesloten — dit kan pas weer als de inschrijvingen opnieuw opengaan.',
  network: 'Geen verbinding met de server. Controleer je internet en probeer opnieuw.',
}

export function foutTekst(error: string, fallback: string): string {
  return GEDEELDE_FOUTEN[error] ?? fallback
}

export async function api<T>(path: string, init?: RequestInit): Promise<ApiResult<T>> {
  let res: Response
  try {
    res = await fetch(path, {
      ...init,
      headers: {
        'Content-Type': 'application/json',
        ...(init?.headers ?? {}),
      },
    })
  } catch (err) {
    console.error('[api] network error', err)
    return { ok: false, status: 0, error: 'network' }
  }
  let payload: any = null
  try {
    payload = await res.json()
  } catch {
    return { ok: false, status: res.status, error: 'bad-json' }
  }
  if (!res.ok || payload?.ok === false) {
    return {
      ok: false,
      status: res.status,
      error: payload?.error ?? `http-${res.status}`,
      errors: payload?.errors,
    }
  }
  return { ok: true, data: payload as T }
}
